// extracted by mini-css-extract-plugin
export default {"colorButtons":"ColorPicker_colorButtons__5uMN0","colorButton":"ColorPicker_colorButton__blvMh"};